export const ExploreIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.25 5.188A2.437 2.437 0 0 1 4.688 2.75h8.625a2.437 2.437 0 0 1 2.437 2.438v8.625a2.438 2.438 0 0 1-2.438 2.437H4.688a2.438 2.438 0 0 1-2.438-2.438V5.188Zm2.438-1.313a1.313 1.313 0 0 0-1.313 1.313v8.625c0 .724.588 1.312 1.313 1.312H6.75V3.875H4.687Zm3.187 0V11h6.75V5.187a1.313 1.313 0 0 0-1.313-1.312H7.875Zm6.75 8.25h-6.75v3h5.438a1.313 1.313 0 0 0 1.312-1.313v-1.687Z"
    />
  </svg>
);
